import PubSub from 'underpub-js';
import gsap from 'gsap';

var Header = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-Header',
  };

  $.extend(true, this.options, options);
};

Header.prototype.init = function() {
  var self = this;

  self.$mobileNav = self.options.$el.find(
    `.${self.data.baseClass}__mobile-nav`,
  );
  self.$hamburger = self.options.$el.find(`.${self.data.baseClass}__hamburger`);
  self.$search = self.options.$el.find(`.${self.data.baseClass}__search`);
  self.$searchSVG = self.$search.find('svg');

  self.$hamburger.on('click', () => self.toggleNav());

  self.initSubnavMobile();
  self.initSubnavDesktop();
  self.initMobileNav();

  PubSub.subscribe('resizeWidth', () => self.closeNav(2));
};

Header.prototype.generateHamburgerTL = function() {
  const self = this;
  const $hamburger = self.$hamburger;
  const $line = $hamburger.find('.line');
  const $top = $hamburger.find('.top');
  const $topLine = $top.find($line);
  const $middle = $hamburger.find('.middle');
  const $middleLine = $top.find($line);
  const $bottom = $hamburger.find('.bottom');
  const $bottomLine = $bottom.find($line);

  const tl = gsap
    .timeline()
    .to($line, {
      duration: 0.2,
      width: 0,
    })
    .set($line, {
      backgroundColor: '#000000',
    })
    .set($top, {
      top: -1,
    })
    .set($top, {
      bottom: -3,
    })
    .set([$top, $bottom], {
      left: 2,
      width: '122%',
    })
    .set($topLine, { rotation: 45 })
    .set($bottomLine, { rotation: -45 })
    .to([$topLine, $bottomLine], {
      duration: 0.25,
      width: '100%',
    });

  return tl;
};

Header.prototype.generateMobileNavMenuTL = function() {
  const self = this;
  const $mobileNavInner = self.$mobileNav.find(
    `.${self.data.baseClass}__mobile-nav__inner`,
  );

  const tl = gsap
    .timeline()
    .set(self.$mobileNav, {
      visibility: 'visible',
    })
    .from(self.$mobileNav, {
      opacity: 0,
      duration: 0.25,
      scale: 0.97,
      ease: 'expo.easeout',
    })
    .from(
      $mobileNavInner.children(),
      {
        opacity: 0,
        duration: 0.3,
        ease: 'expo.easeout',
        y: 10,
      },
      '<.3',
    );

  return tl;
};

Header.prototype.initMobileNav = function() {
  const self = this;

  self.navTL = gsap.timeline({
    paused: true,
    reversed: true,
    onStart: () => self.toggleNavState(),
    onReverseComplete: () => {
      self.toggleNavState();
      PubSub.publish('headerClosed');
    },
  });

  const hamburgerTL = self.generateHamburgerTL();
  const navMenuTL = self.generateMobileNavMenuTL();

  self.navTL
    .add(hamburgerTL)
    .to(
      self.$searchSVG,
      {
        fill: '#000000',
      },
      '<',
    )
    .add(navMenuTL, '<.2');
};

Header.prototype.toggleNavState = function() {
  const self = this;

  self.data.navIsOpen = !self.data.navIsOpen;
};

Header.prototype.openNav = function(speed = 1) {
  const self = this;

  if (self.data.navIsOpen || self.navTL.isActive()) return;

  self.navTL.timeScale(speed).play();
};

Header.prototype.closeNav = function(speed = 1.5) {
  const self = this;

  if (!self.data.navIsOpen || self.navTL.isActive()) return;

  self.navTL.timeScale(speed).reverse();
};

Header.prototype.toggleNav = function() {
  const self = this;

  self.navTL.reversed() ? self.openNav() : self.closeNav();
};

Header.prototype.initSubnavMobile = function() {
  const self = this;
  const mobileNavPrimaryMenuItemClass = `${self.data.baseClass}__mobile-nav__primary__menu__item`;

  const $mobileNavItemWithSubnav = self.$mobileNav.find(
    `.${mobileNavPrimaryMenuItemClass}.has-subnav`,
  );

  $mobileNavItemWithSubnav.each((index, item) => {
    const $item = $(item);
    const $carat = $item.find(`.${mobileNavPrimaryMenuItemClass}__carat`);
    const $caratSVG = $carat.find('svg');
    const $subnav = $item.find(`.${mobileNavPrimaryMenuItemClass}__subnav`);
    const $subnavInner = $item.find(
      `.${mobileNavPrimaryMenuItemClass}__subnav__inner`,
    );
    const subnavInnerHeight = $subnavInner.outerHeight(true);

    let subnavIsShown = false;

    const subnavTL = gsap
      .timeline({
        paused: true,
        onStart: () => (subnavIsShown = true),
        onReverseComplete: () => (subnavIsShown = false),
      })
      .to($caratSVG, {
        fill: '#b04c2c',
        rotate: -180,
        duration: 0.3,
        y: -1,
        ease: 'expo.easeout',
      })
      .to(
        $subnav,
        {
          height: 'auto',
          ease: 'expo.easeout',
          duration: 0.5,
        },
        '<.15',
      )
      .from(
        $subnavInner,
        {
          opacity: 0,
          duration: 0.25,
          ease: 'expo.easeout',
        },
        '-=.3',
      );

    const closeSubnav = () =>
      subnavIsShown && subnavTL.timeScale(1.3).reverse();
    const openSubnav = () => !subnavIsShown && subnavTL.timeScale(1).play();

    const toggleSubnav = () => {
      $mobileNavItemWithSubnav.trigger('closeSubnav');
      subnavIsShown ? closeSubnav() : openSubnav();
    };

    $carat.on('click', toggleSubnav);
    $item.on('closeSubnav', closeSubnav);
    PubSub.subscribe('resizeWidth', closeSubnav);
    PubSub.subscribe('headerClosed', closeSubnav);
  });
};

Header.prototype.initSubnavDesktop = function() {
  const self = this;
  const primaryMenuItemClass = `${self.data.baseClass}__nav__primary__menu__item`;

  const $itemWithSubnav = self.options.$el.find(
    `.${primaryMenuItemClass}.has-subnav`,
  );

  $itemWithSubnav.each((index, item) => {
    const $item = $(item);
    const $subnav = $item.find(`.${primaryMenuItemClass}__subnav`);
    const $subnavInner = $item.find(`.${primaryMenuItemClass}__subnav__inner`);
    const $submenus = $item.find(`.${primaryMenuItemClass}__submenu`);
    let subnavIsShown = false;

    const subnavTL = gsap
      .timeline({
        paused: true,
        onStart: () => (subnavIsShown = true),
        onReverseComplete: () => (subnavIsShown = false),
      })
      .set($subnav, {
        delay: 0.2,
        autoAlpha: 1,
      })
      .from($subnavInner, {
        duration: 0.3,
        ease: 'expo.easeout',
        opacity: 0,
        y: 20,
      })
      .from(
        $submenus,
        {
          duration: 0.35,
          ease: 'expo.easeout',
          opacity: 0,
          y: 10,
        },
        '<.1',
      );

    const closeSubnav = () => subnavIsShown && subnavTL.timeScale(2).reverse();
    const openSubnav = () => !subnavIsShown && subnavTL.timeScale(1).play(0);

    $item.on('mouseenter', openSubnav).on('mouseleave', closeSubnav);

    PubSub.subscribe('resizeWidth', closeSubnav);
  });
};

export default Header;
